"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable camelcase */
const chart_color_purple_100_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_purple_100"));
const chart_color_purple_200_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_purple_200"));
const chart_color_purple_300_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_purple_300"));
const chart_color_purple_400_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_purple_400"));
const chart_color_purple_500_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_color_purple_500"));
const color_theme_1 = require("../color-theme");
// Color scale
// See https://docs.google.com/document/d/1cw10pJFXWruB1SA8TQwituxn5Ss6KpxYPCOYGrH8qAY/edit
const COLOR_SCALE = [
    chart_color_purple_300_1.default.value,
    chart_color_purple_100_1.default.value,
    chart_color_purple_500_1.default.value,
    chart_color_purple_200_1.default.value,
    chart_color_purple_400_1.default.value
];
exports.LightPurpleColorTheme = color_theme_1.ColorTheme({
    COLOR_SCALE
});
//# sourceMappingURL=purple-color-theme.js.map